import api from '../../../../helpers/api_helper';
import type {
  PlayersQuery,
  PlayersResponse,
} from '../types';

const DEFAULT_PAGE_SIZE = 25;

export const fetchPlayers = async (
  query: PlayersQuery,
): Promise<PlayersResponse> => {
  const params = new URLSearchParams();

  params.set('page', String(query.page || 1));
  params.set('page_size', String(query.page_size || DEFAULT_PAGE_SIZE));
  params.set('is_staff', 'false');
  params.set('is_superuser', 'false');
  params.set('order_by', 'available_balance');

  if (query.balanceSort === 'desc') {
    params.set('reverse', 'true');
  }

  const search = query.search?.trim();
  if (search) {
    params.set('search', search);
  }

  const response = await api.get(`/users/?${params.toString()}`);

  return {
    users: Array.isArray(response.data?.users) ? response.data.users : [],
    total_count: Number(response.data?.total_count || 0),
    filtered_count: Number(response.data?.filtered_count || 0),
    pagination: response.data?.pagination || null,
  };
};
